import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "d-flex flex-wrap" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        orders: Object,
    },
    setup(__props) {
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        onMounted(() => {
        });
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Bestellungen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Bestellungen", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: props.orders,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['status', 'orderId', 'customer.company', 'totalPrice', 'totalWeight', 'deliveryDate', 'createdAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Status",
                                        sortable: true,
                                        sortField: "status"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("a", {
                                                href: _ctx.route('admin.orders.edit', slotProps.data.uuid)
                                            }, _toDisplayString(slotProps.data.status), 9, _hoisted_3)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "orderId",
                                        header: "Bestellnr.",
                                        sortable: true,
                                        sortField: "orderId"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Kunde",
                                        sortable: true,
                                        sortField: "customer"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("a", {
                                                href: _ctx.route('admin.customers.edit', slotProps.data.customer.uuid)
                                            }, _toDisplayString(slotProps.data.customer.company) + " - " + _toDisplayString(slotProps.data.customer.name), 9, _hoisted_4)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Preis",
                                        sortable: true,
                                        sortField: "totalPrice"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(slotProps.data.totalPrice)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Gewicht",
                                        sortable: true,
                                        sortField: "totalWeight"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.data.totalWeight / 1000) + " kg ", 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Lieferdatum",
                                        sortable: true,
                                        sortField: "deliveryDate"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.deliveryDate, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('admin.orders.edit', slotProps.data.uuid),
                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-pencil-square text-white",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                })
                                                            ], -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
